import React, { memo } from 'react';

const ServicesPage = () => {
  return <div>Under construction</div>;
}

export default memo(ServicesPage);
